// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@guestsupply/XDL/Utilities";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { Typography } from "@insite/mobius/index";
import { TypographyProps } from "@insite/mobius/Typography";
import React from "react";
import { css } from "styled-components";

export interface ChangeCustomerTitleStyles {
    titleText?: TypographyProps;
}

export const titleStyles: ChangeCustomerTitleStyles = {};

const styles = titleStyles;

const changeCustomerTitle: React.FC = () => (
    <Typography {...styles.titleText}>{translate("Select Billing & Shipping")}</Typography>
);

const widgetModule: WidgetModule = {
    component: changeCustomerTitle,
    definition: {
        allowedContexts: ["ChangeCustomerPage"],
        group: "My Account",
    },
};

export default widgetModule;
